import React, { useEffect, useState } from 'react';
import { useSearchParams, useNavigate } from 'react-router-dom';
import axios from '../../api/axiosConfig';
import icon from '../../assets/testresult.svg';
import { getTestTitle, getScoreInterpretation } from '../../utils/testScoreUtils';

const TestResultPage: React.FC = () => {
  const [searchParams] = useSearchParams();
  const navigate = useNavigate();
  const [isSaved, setIsSaved] = useState(false);

  const testType = searchParams.get('test');
  const score = Number(searchParams.get('score'));

  const interpretation = getScoreInterpretation(testType, score);
  const title = getTestTitle(testType);

  const handleSaveResult = async () => {
    try {
      await axios.post('/api/test-results', { testType, score });
      setIsSaved(true);
      alert('결과가 저장되었습니다.');
    } catch (error) {
      console.error('Failed to save test result:', error);
      alert('결과 저장에 실패했습니다.');
    }
  };

  return (
    <div className="app-container test-result-page">
      <div className="page-header">
        <img src={icon} alt="Mind Thermometer Icon" className="page-header__icon" />
        <h2 className="page-header__title">검사 결과</h2>
        <p className="page-header__subtitle">
          다양한 검사를 통해 자신의 마음 상태를 점검해 보세요.
        </p>
      </div>
      <div className="result-card">
        <p className="scoreTitle">총점</p>
        <h3>{score}점</h3>
        <p className="testTitle">{title}</p>
        <p className="interpretation-text">{interpretation}</p>
        <div className="button-group">
          <button onClick={handleSaveResult} disabled={isSaved} className="save-button">
            {isSaved ? '저장 완료' : '결과 저장하기'}
          </button>
        </div>
      </div>
      <button onClick={() => navigate('/tests')} className="back-button">
        다른 검사 하러가기
      </button>
    </div>
  );
};

export default TestResultPage;
